import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface PopupDetialRequest {
    category: string;
    idx: string;
}

export interface PopupDetailResponse {
    // statusCode: number;
    // message: string;
    // data: {
    idx: number;
    vTitle: string;
    vPopSizeW: number;
    vPopSizeH: number;
    vPopX: number;
    vPopY: number;
    cViewYN: string;
    cTodayYN: string;
    cPvL: string;
    vContent: string;
    // };
}

export const useGetConsolePopupDetail = ({ category, idx }: PopupDetialRequest): UseQueryResult<PopupDetailResponse, Error> => {
    let url = enum_api_uri.get_console_popup_detail.replace(":category", category).replace(":idx", idx);
    return useQuery({
        queryKey: ["useGetConsolePopupDetail", category, idx],
        queryFn: async () => {
            const response = await axiosInstance.get(
                url,
                //     {
                //     params: {
                //         category,
                //         list_no,
                //     },
                // }
            );
            return response.data.data;
        },
        enabled: !!idx,
    });
};
